module.exports = __webpack_public_path__ + "static/media/back.80e6f9f5.svg";